var _excluded = ["isIndeterminate", "isChecked"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { tqc } from '../../system';
import { Icon } from '../icon';
var CheckIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  viewBox: "0 0 512 512",
  width: 4,
  css: {
    stroke: 'currentColor',
    strokeWidth: '1em'
  }
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
}));
var IndeterminateIcon = props => /*#__PURE__*/React.createElement(Icon, _extends({
  width: 4,
  viewBox: "0 0 448 512",
  css: {
    stroke: 'currentColor',
    strokeWidth: '2em'
  }
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
}));
var CheckboxContainer = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(tqc.div, {
    css: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }
  }, children);
};
/**
 * CheckboxIcon is used to visually indicate the checked or indeterminate
 * state of a checkbox.
 */
export var CheckboxIcon = props => {
  var {
      isIndeterminate,
      isChecked
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(CheckboxContainer, null, isIndeterminate ? /*#__PURE__*/React.createElement(IndeterminateIcon, rest) : /*#__PURE__*/React.createElement(CheckIcon, rest));
};